/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import { Fieldset } from "primereact/fieldset"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import { confirmation } from "../../../types/dropDownTypes"
import CustomToolBar from "../../../ToolBar/customToolbar"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
} from "../../../utils/utils"
import { errorMessages } from "../../../types/messages"
import ServicesRow from "./ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"
const Services3 = (props) => {
  const { showToolBar, disabled } = props

  const {
    handleSubmitPut,
    interview,
    handleLoadNext,
    handleLoadPrev,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [plannedServices3, setPlannedServices3] = useState(
    interview[INTERVIEW_SECTIONS.PLANNED_SERVICES_3]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.PLANNED_SERVICES_3 &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.PLANNED_SERVICES_3
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.PLANNED_SERVICES_3,
      plannedServices3
    )
    if (prevForm) {
      handleLoadPrev(true)
      setNextForm(sections[activeIndex - 1].section)
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICES3_DATA, {
          GpraBServicesCm1: plannedServices3?.gpra_b_services_cm_1,
          GpraBServicesCm2: plannedServices3?.gpra_b_services_cm_2,
          GpraBServicesCm3a: plannedServices3?.gpra_b_services_cm_3a,
          GpraBServicesCm3b: plannedServices3?.gpra_b_services_cm_3b,
          GpraBServicesCm4: plannedServices3?.gpra_b_services_cm_4,
          GpraBServicesCm5: plannedServices3?.gpra_b_services_cm_5,
          GpraBServicesCm6a: plannedServices3?.gpra_b_services_cm_6a,
          GpraBServicesCm6b: plannedServices3?.gpra_b_services_cm_6b,
          GpraBServicesCm6c: plannedServices3?.gpra_b_services_cm_6c,
          GpraBServicesCm7: plannedServices3?.gpra_b_services_cm_7,
          GpraBServicesCm8: plannedServices3?.gpra_b_services_cm_8,
          GpraBServicesCm9: plannedServices3?.gpra_b_services_cm_9,
          GpraBServicesCm10: plannedServices3?.gpra_b_services_cm_10,
          GpraBServicesCm10a: plannedServices3?.gpra_b_services_cm_10a,
          GpraBServicesMs1: plannedServices3?.gpra_b_services_ms_1,
          GpraBServicesMs2: plannedServices3?.gpra_b_services_ms_2,
          GpraBServicesMs3: plannedServices3?.gpra_b_services_ms_3,
          GpraBServicesMs4: plannedServices3?.gpra_b_services_ms_4,
          GpraBServicesMs5: plannedServices3?.gpra_b_services_ms_5,
          GpraBServicesMs6: plannedServices3?.gpra_b_services_ms_6,
          GpraBServicesMs7: plannedServices3?.gpra_b_services_ms_7,
          GpraBServicesMs8: plannedServices3?.gpra_b_services_ms_8,
          GpraBServicesMs8a: plannedServices3?.gpra_b_services_ms_8a,
          GpraBServicesAcs1: plannedServices3?.gpra_b_services_acs_1,
          GpraBServicesAcs2: plannedServices3?.gpra_b_services_acs_2,
          GpraBServicesAcs3: plannedServices3?.gpra_b_services_acs_3,
          GpraBServicesAcs4: plannedServices3?.gpra_b_services_acs_4,
          GpraBServicesAcs5: plannedServices3?.gpra_b_services_acs_5,
          GpraBServicesAcs6: plannedServices3?.gpra_b_services_acs_6,
          GpraBServicesAcs6a: plannedServices3?.gpra_b_services_acs_6a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraBServicesId: plannedServices3?.gpra_b_services_id,
          Additional: getAdditionalQuestions(plannedServices3),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(sections[activeIndex + 1].section)
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ plannedServices3: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        handleLoadNext(false)
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      plannedServices3?.gpra_b_services_cm_1 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_1 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_2 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_2 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_3a === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_3a = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_3b === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_3b = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_4 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_4 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_5 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_5 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_6a === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_6a = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_6b === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_6b = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_6c === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_6c = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_7 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_7 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_8 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_8 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_9 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_9 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_cm_10 === undefined &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      errors.gpra_b_services_cm_10 = errorMessages.requiredMessage
    } else if (
      plannedServices3?.gpra_b_services_cm_10 &&
      showQuestion(questions, "gpra_b_services_cm_1")
    ) {
      if (!plannedServices3?.gpra_b_services_cm_10a) {
        errors.gpra_b_services_cm_10a = errorMessages.requiredMessage
      }
    }
    if (
      plannedServices3?.gpra_b_services_ms_1 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_1 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_ms_2 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_2 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_ms_3 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_3 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_ms_4 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_4 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_ms_5 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_5 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_ms_6 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_6 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_ms_7 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_7 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_ms_8 === undefined &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      errors.gpra_b_services_ms_8 = errorMessages.requiredMessage
    } else if (
      plannedServices3?.gpra_b_services_ms_8 &&
      showQuestion(questions, "gpra_b_services_ms_1")
    ) {
      if (!plannedServices3?.gpra_b_services_ms_8a) {
        errors.gpra_b_services_ms_8a = errorMessages.requiredMessage
      }
    }
    if (
      plannedServices3?.gpra_b_services_acs_1 === undefined &&
      showQuestion(questions, "gpra_b_services_acs_1")
    ) {
      errors.gpra_b_services_acs_1 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_acs_2 === undefined &&
      showQuestion(questions, "gpra_b_services_acs_1")
    ) {
      errors.gpra_b_services_acs_2 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_acs_3 === undefined &&
      showQuestion(questions, "gpra_b_services_acs_1")
    ) {
      errors.gpra_b_services_acs_3 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_acs_4 === undefined &&
      showQuestion(questions, "gpra_b_services_acs_1")
    ) {
      errors.gpra_b_services_acs_4 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_acs_5 === undefined &&
      showQuestion(questions, "gpra_b_services_acs_1")
    ) {
      errors.gpra_b_services_acs_5 = errorMessages.requiredMessage
    }
    if (
      plannedServices3?.gpra_b_services_acs_6 === undefined &&
      showQuestion(questions, "gpra_b_services_acs_1")
    ) {
      errors.gpra_b_services_acs_6 = errorMessages.requiredMessage
    } else if (
      plannedServices3?.gpra_b_services_acs_6 &&
      showQuestion(questions, "gpra_b_services_acs_1")
    ) {
      if (!plannedServices3?.gpra_b_services_acs_6a) {
        errors.gpra_b_services_acs_6a = errorMessages.requiredMessage
      }
    }
    setValidationErrors(
      validateQuestions(
        plannedServices3,
        INTERVIEW_SECTIONS.PLANNED_SERVICES_3,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_b_services_cm_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Case Management Services`} />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`1. Family Services (Including Marriage Education, Parenting, Child Development Services)`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_1}
              setDrop={"gpra_b_services_cm_1"}
              dropError={validationErrors.gpra_b_services_cm_1}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`2. Child Care`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_2}
              setDrop={"gpra_b_services_cm_2"}
              dropError={validationErrors.gpra_b_services_cm_2}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              showNumber={false}
              showDrop={false}
              removeError={removeError}
              label={`3. Employement Service`}
              summaryDisabled={disabled}
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label="A. Pre-Employment"
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_3a}
              setDrop={"gpra_b_services_cm_3a"}
              dropError={validationErrors.gpra_b_services_cm_3a}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label="B. Employment Coaching"
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_3b}
              setDrop={"gpra_b_services_cm_3b"}
              dropError={validationErrors.gpra_b_services_cm_3b}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`4. Individual Services Coordination`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_4}
              setDrop={"gpra_b_services_cm_4"}
              dropError={validationErrors.gpra_b_services_cm_4}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`5. Transportation`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_5}
              setDrop={"gpra_b_services_cm_5"}
              dropError={validationErrors.gpra_b_services_cm_5}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              showDrop={false}
              showNumber={false}
              label={`6. HIV/AIDS Services`}
              summaryDisabled={disabled}
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label="A. If HIV Neg, Pre-Exposure Prophylaxis"
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_6a}
              setDrop={"gpra_b_services_cm_6a"}
              dropError={validationErrors.gpra_b_services_cm_6a}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label="B. If HIV Neg, Post-Exposure Prophylaxis"
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_6b}
              setDrop={"gpra_b_services_cm_6b"}
              dropError={validationErrors.gpra_b_services_cm_6b}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label="C. If HIV Positive, HIV Treatment"
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_6c}
              setDrop={"gpra_b_services_cm_6c"}
              dropError={validationErrors.gpra_b_services_cm_6c}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`7. Transitional Drug-Free Housing Service`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_7}
              setDrop={"gpra_b_services_cm_7"}
              dropError={validationErrors.gpra_b_services_cm_7}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`8. Housing Support`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_8}
              setDrop={"gpra_b_services_cm_8"}
              dropError={validationErrors.gpra_b_services_cm_8}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`9. Health Insurance Enrollment`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_9}
              setDrop={"gpra_b_services_cm_9"}
              dropError={validationErrors.gpra_b_services_cm_9}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`10. Other Case Management Services (Specify)`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_cm_10}
              setDrop={"gpra_b_services_cm_10"}
              dropError={validationErrors.gpra_b_services_cm_10}
              extraValues={[{ key: "gpra_b_services_cm_10a", value: "" }]}
              summaryDisabled={disabled}
              errorsToRemove={["gpra_b_services_cm_10a"]}
              required
            />
          </div>
          {plannedServices3?.gpra_b_services_cm_10 && (
            <div className={gpraStyles.formServicesRow}>
              <InputText
                className={
                  validationErrors.gpra_b_services_cm_10a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={!plannedServices3?.gpra_b_services_cm_10 || disabled}
                placeholder={
                  !plannedServices3?.gpra_b_services_cm_10
                    ? "Not Applicable"
                    : ""
                }
                value={plannedServices3?.gpra_b_services_cm_10a}
                onChange={(e) => {
                  updateState(
                    "gpra_b_services_cm_10a",
                    e.target.value,
                    null,
                    null,
                    plannedServices3,
                    setPlannedServices3,
                    null
                  )
                  removeError("gpra_b_services_cm_10a")
                }}
              />
              <FormError error={validationErrors.gpra_b_services_cm_10a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_b_services_ms_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Medical Services`} />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`1. Medical Care`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_1}
              setDrop={"gpra_b_services_ms_1"}
              dropError={validationErrors.gpra_b_services_ms_1}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`2. Alcohol/Drug Testing`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_2}
              setDrop={"gpra_b_services_ms_2"}
              dropError={validationErrors.gpra_b_services_ms_2}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`3. OB/GYN Services`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_3}
              setDrop={"gpra_b_services_ms_3"}
              dropError={validationErrors.gpra_b_services_ms_3}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`4. HIV/AIDS Medical Support & Testing`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_4}
              setDrop={"gpra_b_services_ms_4"}
              dropError={validationErrors.gpra_b_services_ms_4}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`5. Dental Care`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_5}
              setDrop={"gpra_b_services_ms_5"}
              dropError={validationErrors.gpra_b_services_ms_5}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`6. Viral Hepatitis Medical Support & Testing`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_6}
              setDrop={"gpra_b_services_ms_6"}
              dropError={validationErrors.gpra_b_services_ms_6}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`7. Other STI Support & Testing`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_7}
              setDrop={"gpra_b_services_ms_7"}
              dropError={validationErrors.gpra_b_services_ms_7}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`8. Other Medical Services (Specify)`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_ms_8}
              setDrop={"gpra_b_services_ms_8"}
              dropError={validationErrors.gpra_b_services_ms_8}
              extraValues={[{ key: "gpra_b_services_ms_8a", value: "" }]}
              summaryDisabled={disabled}
              errorsToRemove={["gpra_b_services_ms_8a"]}
              required
            />
          </div>
          {plannedServices3?.gpra_b_services_ms_8 && (
            <div className={gpraStyles.formServicesRow}>
              <InputText
                className={
                  validationErrors.gpra_b_services_ms_8a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={!plannedServices3?.gpra_b_services_ms_8 || disabled}
                placeholder={
                  !plannedServices3?.gpra_b_services_ms_8
                    ? "Not Applicable"
                    : ""
                }
                value={plannedServices3?.gpra_b_services_ms_8a}
                onChange={(e) => {
                  updateState(
                    "gpra_b_services_ms_8a",
                    e.target.value,
                    null,
                    null,
                    plannedServices3,
                    setPlannedServices3,
                    null
                  )
                  removeError("gpra_b_services_ms_8a")
                }}
              />
              <FormError
                error={validationErrors.gpra_b_services_ms_8a}
                errorType={2}
              />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_b_services_acs_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. After Care Services`} />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`1. Continuing Care`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_acs_1}
              setDrop={"gpra_b_services_acs_1"}
              dropError={validationErrors.gpra_b_services_acs_1}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`2. Relapse Prevention`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_acs_2}
              setDrop={"gpra_b_services_acs_2"}
              dropError={validationErrors.gpra_b_services_acs_2}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`3. Recovery Coaching`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_acs_3}
              setDrop={"gpra_b_services_acs_3"}
              dropError={validationErrors.gpra_b_services_acs_3}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`4. Self-Help And Support Groups`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_acs_4}
              setDrop={"gpra_b_services_acs_4"}
              dropError={validationErrors.gpra_b_services_acs_4}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`5. Spiritual Support`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_acs_5}
              setDrop={"gpra_b_services_acs_5"}
              dropError={validationErrors.gpra_b_services_acs_5}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices3}
              setEntity={setPlannedServices3}
              showNumber={false}
              removeError={removeError}
              label={`6. Other After Case Services (Specify)`}
              options={confirmation}
              drop={plannedServices3?.gpra_b_services_acs_6}
              setDrop={"gpra_b_services_acs_6"}
              dropError={validationErrors.gpra_b_services_acs_6}
              extraValues={[{ key: "gpra_b_services_acs_6a", value: "" }]}
              summaryDisabled={disabled}
              errorsToRemove={["gpra_b_services_acs_6a"]}
              required
            />
          </div>
          {plannedServices3?.gpra_b_services_acs_6 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_b_services_acs_6a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={!plannedServices3?.gpra_b_services_acs_6 || disabled}
                placeholder={
                  !plannedServices3?.gpra_b_services_acs_6
                    ? "Not Applicable"
                    : ""
                }
                value={plannedServices3?.gpra_b_services_acs_6a}
                onChange={(e) => {
                  updateState(
                    "gpra_b_services_acs_6a",
                    e.target.value,
                    null,
                    null,
                    plannedServices3,
                    setPlannedServices3,
                    null
                  )
                  removeError("gpra_b_services_acs_6a")
                }}
              />
              <FormError
                error={validationErrors.gpra_b_services_acs_6a}
                errorType={2}
              />
            </div>
          )}
        </>
      )
    }
  }
  return (
    <>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="B. SUBSTANCE USE AND PLANNED SERVICES"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={plannedServices3}
                    setEntity={setPlannedServices3}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.PLANNED_SERVICES_3}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, plannedServices3)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={plannedServices3}
                      setEntity={setPlannedServices3}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.PLANNED_SERVICES_3}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </>
  )
}

Services3.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Services3.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Services3
